import angular from 'angular';
import './error/error-module';
import RestWrapperService from './rest-wrapper-service';
import HttpService from './http-service';

export default angular
  .module('rest', ['error'])
  .config([
    '$httpProvider',
    ($httpProvider) => {
      $httpProvider.useApplyAsync(true);
      $httpProvider.defaults.headers.delete = {
        'content-type': 'application/json',
      };
    },
  ])
  .service('RestWrapperService', RestWrapperService)
  .service('HttpService', HttpService);



// WEBPACK FOOTER //
// ./src/modules/utils/rest/rest-module.js